import { render, staticRenderFns } from "./UserConfirmOTP.vue?vue&type=template&id=2d681341&scoped=true&"
import script from "./UserConfirmOTP.vue?vue&type=script&lang=js&"
export * from "./UserConfirmOTP.vue?vue&type=script&lang=js&"
import style0 from "./UserConfirmOTP.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserConfirmOTP.vue?vue&type=style&index=1&id=2d681341&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d681341",
  null
  
)

export default component.exports